<template>
  <a-layout
    style="min-width: 190px"
    width="100%"
  >
    <a-cascader
      v-model:value="modalRef.selectedRows"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :expandTrigger="field.expandTrigger ? field.expandTrigger : 'click'"
      :changeOnSelect="field.changeOnSelect ? field.expandTrigger : false"
      :options="modalRef.datasource"
      :multiple="field.mode === 'multiple'"
      :maxTagCount="1"
      :placeholder="field.placeholder ? field.placeholder : '请选择' + field.label"
      size="small"
      @change="handleChange"
    />
  </a-layout>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent, onMounted, reactive, watch } from 'vue';
import type { ReponseData } from 'liyu-pc-base/utils/hooks/useFetchData';
import getFormConfig from 'liyu-pc-base/components/FormRender/RemoteCascader/index';

type Field = {
  mode: 'multiple' | 'default';
  modalType: string;
  default: string;
  name: string;
};

export default defineComponent({
  name: 'RemoteCascader',
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
    valueKey: {
      type: String,
    },
    labelKey: {
      type: String,
    },
    labelSpace: {
      type: String,
      default: '-',
    },
    labelKeyList: {
      type: Array,
    },
    value: {
      type: [Array, Number, String],
      required: false,
      default: () => null,
    },
    label: {
      type: [Array, String],
      required: false,
      default: () => [],
    },
    formModel: {
      type: Object,
      required: true,
    },
    init_model: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:value', 'update:label'],
  setup(props, { emit }) {
    const modalRef = reactive({
      selectedRows: [],
      datasource: [],
    });
    if (props.value != null) {
      modalRef.selectedRows.push(props.value);
    }
    const { searchConfig, getData } = getFormConfig(props.field.modalType);
    const search_modelRef = reactive({
      ...searchConfig.model,
      ...props.init_model,
    });
    if (searchConfig.model.pageSize == undefined) {
      search_modelRef.pageSize = 2000;
    }
    const old_obj: { [key: string]: any } = {};
    const get_value_key = () => {
      return props.valueKey ? (props.valueKey as string) : 'value';
    };
    const get_label_key = () => {
      return props.labelKey ? (props.labelKey as string) : 'label';
    };
    const allDataList = [];
    const allParentDataList = [];
    const setAllDataList = () => {
      allDataList.length = 0;
      const flatten_fun = (obj_list: any) => {
        obj_list.forEach((item: any) => {
          if (item.children) {
            allParentDataList.push({
              label: item.label,
              value: item.value,
            });
            flatten_fun(item.children);
          } else {
            allDataList.push({
              label: item.label,
              value: item.value,
            });
          }
        });
      };
      flatten_fun(modalRef.datasource);
    };
    const datasource = computed(() => {
      return modalRef.datasource;
      // return modalRef.datasource.map(item => {
      //   if (props.labelKeyList) {
      //     const label = [];
      //     for (const key of props.labelKeyList) {
      //       label.push(item[key as string]);
      //     }
      //     return {
      //       value: item[get_value_key()],
      //       label: label.join(props.labelSpace),
      //     };
      //   } else {
      //     return {
      //       value: item[get_value_key()],
      //       label: item[get_label_key()],
      //     };
      //   }
      // });
    });
    const getDefaultValue = (list: any) => {
      const label = [];
      const value = props.formModel[props.field.name];
      if (props.field.mode === 'default') {
        if (props.field.field_name_list.length == 1) {
          if (value instanceof Array) {
            value.forEach(x_list => {
              const [last] = [...x_list].reverse();
              const f = alDataList.find(item => item.value == last);
              if (f) {
                label.push(f.label);
              }
              label.push(last);
            });
          }
        } else if (props.field.field_name_list.length > 1) {
          if (value instanceof Array) {
            // props.field.field_name_list.forEach(()=>{
            const last_index = props.field.field_name_list.length - 1;
            value.forEach((v, v_index) => {
              if (v_index === last_index) {
                const f = allDataList.find(item => item.value == v);
                if (f) {
                  label.push(f.label);
                }
              } else {
                const f = allParentDataList.find(item => item.value == v);
                if (f) {
                  label.push(f.label);
                }
              }
            });
            // });
          }
        }
      } else if (props.field.mode === 'multiple') {
        if (props.field.field_name_list.length == 1) {
          if (value instanceof Array) {
            value.forEach(x_list => {
              const [last] = [...x_list].reverse();
              label.push(last);
            });
          }
        } else if (props.field.field_name_list.length > 1) {
          if (value instanceof Array) {
            // props.field.field_name_list.forEach(()=>{
            value.forEach(value_list => {
              if (value_list.length == 1) {
                const [first] = value_list;
                const f = allParentDataList.find(item => item.value == first);
                if (f) {
                  label.push(f.label);
                }
              } else if (value_list.length > 1) {
                const [last] = [...value_list].reverse();
                const f = allDataList.find(item => item.value == last);
                if (f) {
                  label.push(f.label);
                }
              }
            });
            // });
          }
        }
      }
      emit('update:label', label);
    };

    const check_params_need_request = () => {
      let is_ok = true;
      if (searchConfig.watch) {
        for (const k of searchConfig.watch) {
          if (props.formModel) {
            if (
              (props.formModel[k] === null || props.formModel[k] === undefined) &&
              props.init_model &&
              (props.init_model[k] === null || props.init_model[k] === undefined)
            ) {
              is_ok = false;
            }
          }
        }
      }
      return is_ok;
    };
    watch(
      () => props.formModel[props.field.name],
      () => {
        if (props.field.mode === 'default') {
          if (props.formModel[props.field.name] || props.formModel[props.field.name] === 0) {
            modalRef.selectedRows = [props.formModel[props.field.name]];
          } else {
            modalRef.selectedRows = [];
          }
        } else if (props.field.mode === 'multiple') {
          if (props.formModel[props.field.name] && props.formModel[props.field.name].length > 0) {
            modalRef.selectedRows = props.formModel[props.field.name].map((item: any) => {
              return item;
            });
          } else {
            modalRef.selectedRows = [];
          }
        }

        const label = [];
        const value = props.formModel[props.field.name];
        if (props.field.mode === 'default') {
          if (props.field.field_name_list.length == 1) {
            if (value instanceof Array) {
              value.forEach(x_list => {
                const [last] = [...x_list].reverse();
                const f = alDataList.find(item => item.value == last);
                if (f) {
                  label.push(f.label);
                }
                label.push(last);
              });
            }
          } else if (props.field.field_name_list.length > 1) {
            if (value instanceof Array) {
              // props.field.field_name_list.forEach(()=>{
              const last_index = props.field.field_name_list.length - 1;
              value.forEach((v, v_index) => {
                if (v_index === last_index) {
                  const f = allDataList.find(item => item.value == v);
                  if (f) {
                    label.push(f.label);
                  }
                } else {
                  const f = allParentDataList.find(item => item.value == v);
                  if (f) {
                    label.push(f.label);
                  }
                }
              });
              // });
            }
          }
        } else if (props.field.mode === 'multiple') {
          if (props.field.field_name_list.length == 1) {
            if (value instanceof Array) {
              value.forEach(x_list => {
                const [last] = [...x_list].reverse();
                label.push(last);
              });
            }
          } else if (props.field.field_name_list.length > 1) {
            if (value instanceof Array) {
              // props.field.field_name_list.forEach(()=>{
              value.forEach(value_list => {
                if (value_list.length == 1) {
                  const [first] = value_list;
                  const f = allParentDataList.find(item => item.value == first);
                  if (f) {
                    label.push(f.label);
                  }
                } else if (value_list.length > 1) {
                  const [last] = [...value_list].reverse();
                  const f = allDataList.find(item => item.value == last);
                  if (f) {
                    label.push(f.label);
                  }
                }
              });
              // });
            }
          }
        }
        emit('update:label', label);
      },
    );

    onMounted(() => {
      let is_use = false;
      if (searchConfig.watch) {
        for (const k of searchConfig.watch) {
          if (props.formModel) {
            old_obj[k] = props.formModel[k];
          }
        }
      }
      if (searchConfig.watch && props.formModel) {
        for (const k of searchConfig.watch) {
          search_modelRef[k] = props.formModel[k];
          watch(
            () => props.formModel[k],
            () => {
              let change = false;
              if (searchConfig.watch && props.formModel) {
                for (const k of searchConfig.watch) {
                  if (old_obj[k] != props.formModel[k] && props.formModel[k]) {
                    change = true;
                    search_modelRef[k] = props.formModel[k];
                  }
                }
              }
              if (change && check_params_need_request()) {
                getData({ ...search_modelRef }).then(function (res: ReponseData<any>) {
                  const data: any = res.data || res;
                  modalRef.datasource = data;
                  setAllDataList();
                  getDefaultValue(data);
                });
              }
            },
            { immediate: true },
          );
        }
      }
      if (searchConfig.attr_use && searchConfig.attr_use.length > 0) {
        for (const k of searchConfig.attr_use) {
          if (props.formModel && props.formModel[k]) {
            is_use = true;
          } else {
            is_use = false;
            break;
          }
        }
      } else {
        if (check_params_need_request()) {
          getData({ ...search_modelRef }).then(function (res: ReponseData<any>) {
            const data: any = res.data || res;
            modalRef.datasource = data;
            setAllDataList();
            getDefaultValue(data);
          });
        }
      }
      if (is_use && check_params_need_request()) {
        getData({ ...search_modelRef }).then(function (res: ReponseData<any>) {
          const data: any = res.data || res;
          modalRef.datasource = data;
          setAllDataList();
          getDefaultValue(data);
        });
      }
    });

    const handleChange = () => {
      emit('update:value', modalRef.selectedRows);
      const label = [];
      const value = props.formModel[props.field.name];
      if (props.field.mode === 'default') {
        if (props.field.field_name_list.length == 1) {
          if (value instanceof Array) {
            value.forEach(x_list => {
              const [last] = [...x_list].reverse();
              const f = alDataList.find(item => item.value == last);
              if (f) {
                label.push(f.label);
              }
              label.push(last);
            });
          }
        } else if (props.field.field_name_list.length > 1) {
          if (value instanceof Array) {
            // props.field.field_name_list.forEach(()=>{
            const last_index = props.field.field_name_list.length - 1;
            value.forEach((v, v_index) => {
              if (v_index === last_index) {
                const f = allDataList.find(item => item.value == v);
                if (f) {
                  label.push(f.label);
                }
              } else {
                const f = allParentDataList.find(item => item.value == v);
                if (f) {
                  label.push(f.label);
                }
              }
            });
            // });
          }
        }
      } else if (props.field.mode === 'multiple') {
        if (props.field.field_name_list.length == 1) {
          if (value instanceof Array) {
            value.forEach(x_list => {
              const [last] = [...x_list].reverse();
              label.push(last);
            });
          }
        } else if (props.field.field_name_list.length > 1) {
          if (value instanceof Array) {
            // props.field.field_name_list.forEach(()=>{
            value.forEach(value_list => {
              if (value_list.length == 1) {
                const [first] = value_list;
                const f = allParentDataList.find(item => item.value == first);
                if (f) {
                  label.push(f.label);
                }
              } else if (value_list.length > 1) {
                const [last] = [...value_list].reverse();
                const f = allDataList.find(item => item.value == last);
                if (f) {
                  label.push(f.label);
                }
              }
            });
            // });
          }
        }
      }
      emit('update:label', label);
    };

    return {
      props,
      modalRef,
      search_modelRef,
      searchConfig,
      handleChange,
      datasource,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
  components: {},
});
</script>
